import { createContext } from "react";

// Lets deep children (the embedded chart) drive app-shell chrome, e.g. collapse
// the sidebar to an icon rail while an encounter is being charted.
export const ChromeContext = createContext({ setSidebarCollapsed: () => {} });
